import { ExternalLink, FileText, Image as ImageIcon } from "lucide-react";

import { openProtected } from "@/lib/api";
import { useToast } from "@/components/toast";
import { C, dateTime, STATUSES, STATUS_LABELS } from "@/lib/format";

export function StatusTimeline({ current, history }) {
  const idx = STATUSES.indexOf(current);
  const byStatus = Object.fromEntries(history.map((h) => [h.status, h]));
  return (
    <ol data-testid="status-timeline" className="flex flex-col">
      {STATUSES.map((s, i) => {
        const done = i <= idx;
        const h = byStatus[s];
        const col = done ? (i >= 4 ? C.success : C.brand) : C.borderStrong;
        return (
          <li key={s} className="flex gap-3" data-testid={`timeline-step-${s}`}>
            <div className="flex w-5 flex-col items-center">
              <span className="mt-0.5 h-4 w-4 rounded-full border-2" style={{ borderColor: col, backgroundColor: done ? col : "transparent" }} />
              {i < STATUSES.length - 1 && <span className="min-h-6 w-0.5 flex-1" style={{ backgroundColor: i < idx ? col : C.border }} />}
            </div>
            <div className="flex-1 pb-3">
              <p className={`text-sm ${i === idx ? "font-bold" : ""}`} style={{ color: done ? C.onSurface : C.muted }}>
                {STATUS_LABELS[s]}
              </p>
              {h && done ? (
                <p className="t-caption">
                  {dateTime(h.at)}
                  {h.note ? ` · ${h.note}` : ""}
                </p>
              ) : null}
            </div>
          </li>
        );
      })}
    </ol>
  );
}

export function FileList({ files }) {
  const toast = useToast();
  if (!files.length) return <p className="t-caption">Aucun document joint.</p>;
  return (
    <div className="flex flex-col gap-2">
      {files.map((f) => {
        const Icon = f.content_type.startsWith("image") ? ImageIcon : FileText;
        return (
          <button
            key={f.id}
            type="button"
            data-testid={`file-open-${f.id}`}
            onClick={() => openProtected(`/files/${f.id}`).catch((e) => toast(e.message, "error"))}
            className="focus-ring flex items-center gap-2 rounded-xl bg-[#2A2A2A] p-3 text-left transition-colors hover:bg-[#333333]"
          >
            <Icon className="h-5 w-5 shrink-0 text-[#D4AF37]" aria-hidden />
            <span className="t-body flex-1 truncate">{f.name}</span>
            <ExternalLink className="h-[18px] w-[18px] text-[#9E9E9E]" aria-hidden />
          </button>
        );
      })}
    </div>
  );
}
